import { SWReactIcons } from "@similarweb/icons";
import { PlainTooltip } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";

import I18n from "../../../../common-components/i18n/I18n";
import { quotaKeys } from "../../utils/i18n";

import * as styles from "./styles";
import { StyledText } from "./styles";

type QuotaProps = {
    allUniqueWebsites: readonly string[];
    quotaLimit: number;
};

const Quota = (props: QuotaProps) => {
    const { allUniqueWebsites, quotaLimit } = props;

    return (
        <styles.StyledQuotaContainer className="fadeIn">
            <I18n
                data-automation="sales-intelligence-quota-text"
                element={StyledText}
                translatable={quotaKeys.websitesQuota({
                    numberOfWebsites: allUniqueWebsites.length,
                    limit: quotaLimit,
                })}
            />
            <PlainTooltip tooltipContent={translate(quotaKeys.quotaTooltip)}>
                <styles.StyledTooltipContent>
                    <SWReactIcons
                        iconName="info"
                        size="xs"
                    />
                </styles.StyledTooltipContent>
            </PlainTooltip>
        </styles.StyledQuotaContainer>
    );
};

export default Quota;
